import { css, Interpolation, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  width: 100%;
  max-width: 1190px;
  margin: 0 auto;
  min-height: 100%;
  padding: ${theme.spacing(4)} ${theme.spacing(3)};
`

export const header = (theme: Theme) => css`
  display: block;
  margin: ${theme.spacing(2)} 0;

  font-weight: 700;
`

export const sectionTabs = (theme: Theme) => css`
  margin: ${theme.spacing(4, 0, 2)};
`

export const tabs = (theme: Theme) => css`
  margin: ${theme.spacing(2, 0, 3)};
`

export const link: Interpolation<Theme> = (theme: Theme) => css`
  gap: 5px;
  padding: 6px 6px 6px 10px;
  border-radius: 38px;
  color: ${theme.colors.typographyThree};
  background: ${theme.colors.backgroundOne};

  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
`

export const ellipsis: Interpolation<Theme> = css`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const tablesWrapper: Interpolation<Theme> = css`
  margin-top: 24px;
`

export const table: Interpolation<Theme> = css`
  .table-header .table-cell {
    font-weight: 700;
  }

  .table-row {
    padding: 5px 12px;
  }
`

export const block = css`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin-top: 24px;
`

export const title: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 700;
  margin: 32px 0;
`

export const question: Interpolation<Theme> = css`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin-top: 30px;
`

export const searchInput: Interpolation<Theme> = css`
  margin-top: 24px;
`

export const searchIcon: Interpolation<Theme> = (theme) => css`
  min-width: 22px;
  color: ${theme.typographyColors.typographyThree};
`

export const emptyData: Interpolation<Theme> = css`
  margin-top: 24px;
  text-align: center;
`

export const infiniteScroll: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
  overflow-y: auto;
`
